import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import handleAxiosResponseSuccess from './utils/handleAxiosResponseSuccess';

const Http = axios.create();
const TechsPdvApi = axios.create();
const HttpTechNfe = axios.create();
const HttpTechServico = axios.create();
const Http2 = axios.create();
const HttpTechFood = axios.create();
const AUTH_BASE_URL = process.env.REACT_APP_AUTH_SERVER_BASE_URL;
const NFCE_BASE_URL = process.env.REACT_APP_NFCE_URL;
const SERVICO_BASE_URL = process.env.REACT_APP_SERVICO_URL;

const HTTPTECHFOOD_BASE_URL = process.env.REACT_APP_HTTPTECHFOOD_URL;
const TECHSPDV_BASE_URL = process.env.REACT_APP_TECHSPDV_URL;

class Service {
  protected static Http = Http;
  protected static TechsPdvApi = TechsPdvApi;
  protected static Http2 = Http2;
  protected static HttpTechNfe = HttpTechNfe;
 protected static HttpTechServico = HttpTechServico;



  protected static HttpTechFood = HttpTechFood;
  protected static getData = getData;

  public static setRequestInterceptors(
    onFulfilled: (
      request: AxiosRequestConfig
    ) => AxiosRequestConfig | Promise<AxiosRequestConfig>,
    onRejected?: (error: any) => any
  ) {
    Http.interceptors.request.use(onFulfilled, onRejected);
    HttpTechNfe.interceptors.request.use(onFulfilled, onRejected);
    HttpTechServico.interceptors.request.use(onFulfilled, onRejected);




    HttpTechFood.interceptors.request.use(onFulfilled, onRejected);
    TechsPdvApi.interceptors.request.use(onFulfilled, onRejected);
  }

  public static setResponseInterceptors(
    onFulfilled: (response: AxiosResponse) => AxiosResponse | Promise<AxiosResponse>,
    onRejected: (error: any) => any
  ) {
    Http.interceptors.response.use(onFulfilled, onRejected);
    HttpTechNfe.interceptors.response.use(onFulfilled, onRejected);
    HttpTechServico.interceptors.response.use(onFulfilled, onRejected);



    //TechsPdvApi.interceptors.response.use(onFulfilled, onRejected);
    HttpTechFood.interceptors.response.use(onFulfilled, onRejected);
  }
}

function getData<T>(res: AxiosResponse<T>) {
  return res.data;
}

Http.defaults.baseURL = AUTH_BASE_URL;
TechsPdvApi.defaults.baseURL = TECHSPDV_BASE_URL;
HttpTechNfe.defaults.baseURL = NFCE_BASE_URL;
HttpTechServico.defaults.baseURL = SERVICO_BASE_URL;
Http2.defaults.baseURL = '';
HttpTechFood.defaults.baseURL = HTTPTECHFOOD_BASE_URL;

export default Service;
